import { connect, ConnectedProps } from 'react-redux'

import ContentHeader from 'components/accordion/ContentHeader'
import { RootState } from 'redux/store'

const mapStateToProps = (state: RootState): { urlNode: RootState['accordion']['urlNode'] } => ({
  urlNode: state.accordion.urlNode
})

export const connector = connect(mapStateToProps, null)
export type ContentHeaderContainerProps = ConnectedProps<typeof connector>

export default connector(ContentHeader)
